import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0106b92"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title sign-line-b" }, "Select Program", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Confirm")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    centered: "",
    wrapClassName: "modal-container",
    onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:visible', false))),
    bodyStyle: {padding: '15px 40px'},
    width: 600
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        class: "m-l-16 min-tbn-w",
        type: "primary",
        onClick: _ctx.handlerConfirm
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_table, {
        class: "tab-container default-self-table-text",
        style: {minHeight: 100 + 'px'},
        dataSource: _ctx.dataSource,
        columns: _ctx.columns,
        bordered: "",
        rowKey: (item, index) => index,
        rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null),
        pagination: false,
        "row-selection": _ctx.rowSelection
      }, null, 8, ["dataSource", "columns", "rowKey", "rowClassName", "row-selection"])
    ]),
    _: 1
  }, 8, ["visible"]))
}